import React, {FC}          from 'react';
import {HBox, BoxAlignment} from '@sirius/ui-lib/src/blocks/Layout';
import {block}              from './block';
import './styles.less';

type Props = {
    social:     Clusters.Social;
    className:  string
};

export const IconsSocial: FC<Props> = ({ social, className }) => (
    <HBox className={className} align={BoxAlignment.center} >
        { Object.entries(social).map( ([icon, link], key) =>
            <a className    = {block + block.mod('media', icon)}
               key          = {key}
               href         = {link}
               rel          = {'noopener noreferrer'}
               target       = {'_blank'}
            />
        )}
    </HBox>
);
